var youtubeRegex1 = /(https?:\/\/)?(www\.)?youtube\.com\/watch.*/i;
var youtubeRegex2 = /(https?:\/\/)?(www\.)?youtu\.be\/(.+)(\?.*)?/i;
var youtubeRegex3 = /(https?:\/\/)?(www\.)?youtube\.com\/embed\/(.+)(\?.*)?/i;

var vimeoRegex1 = /(https?:\/\/)?(www\.)?vimeo.com\/channels\/.+\/(.+)(\?.*)?/i;
var vimeoRegex2 = /(https?:\/\/)?(www\.)?player\.vimeo\.com\/video\/(.+)(\?.*)?/i;
var vimeoRegex3 = /(https?:\/\/)?(www\.)?vimeo\.com\/(.+)(\?.*)?/i;

var youtube = "youtube";
var vimeo = "vimeo";

class VideoServiceURLParser {
  parse(url) {
    var id = false;
    var service = false;
    var groups;

    if (youtubeRegex1.test(url) === true) {
      id = url.split("v=")[1];
      service = youtube;
    } else if (youtubeRegex2.test(url) === true) {
      groups = youtubeRegex2.exec(url);
      id = groups[3];
      service = youtube;
    } else if (youtubeRegex3.test(url) === true) {
      groups = youtubeRegex3.exec(url);
      id = groups[3];
      service = youtube;
    } else if (vimeoRegex1.test(url) === true) {
      groups = vimeoRegex1.exec(url);
      id = groups[3];
      service = vimeo;
    } else if (vimeoRegex2.test(url) === true) {
      groups = vimeoRegex2.exec(url);
      id = groups[3];
      service = vimeo;
    } else if (vimeoRegex3.test(url) === true) {
      groups = vimeoRegex3.exec(url);
      id = groups[3];
      service = vimeo;
    }

    if (id === false || typeof id === "undefined") {
      return false;
    }

    var pos = id.indexOf("?");
    pos = pos === -1 ? id.indexOf("&") : pos;
    id = pos !== -1 ? id.substring(0, pos) : id;

    return {
      service: service,
      id: id,
    };
  }
}

export default new VideoServiceURLParser();
